export interface PromptFile {
  name: string;
  filePath: string;
  requiredVars: Record<string, string>;
  content?: string;
  isOverride?: boolean;
  updatedAt?: string;
  uploadedBy?: string;
  fileId?: string;
}

export interface PromptCollectionMetadata {
  createdAt?: Date;
  updatedAt?: Date;
  author?: string;
  version?: string;
  [key: string]: any;
}

export interface PromptCollection {
  id: string;
  name: string;
  description: string;
  files: PromptFile[];
  metadata?: PromptCollectionMetadata;
}

export function checkRequiredVars(promptText: string, requiredVars: Record<string, string>): boolean {
  return Object.values(requiredVars).every(variable => promptText.includes(variable));
}

export function getRequiredVarsArray(requiredVars: Record<string, string>): string[] {
  return Object.values(requiredVars);
}

export function getRequiredVarsKeys(requiredVars: Record<string, string>): string[] {
  return Object.keys(requiredVars);
}
